import React, { useState, useEffect } from "react";
import s from "./metric-chart.module.scss";

const MetricChart = (props) => {

    const [items, setItems] = useState(props.items ? props.items : []);
    const [labels, setLabels] = useState(props.labels ? props.labels : []);
    const [total, setTotal] = useState(props.total ? props.total : 0);

    useEffect(() => {
        setItems(props.items ? props.items : []);
        setLabels(props.labels ? props.labels : []);
        setTotal(props.total ? props.total : 0);
    }, [props.items, props.total, props.labels]);



    const lines = items.map((k,i) => <div key={i} title={props.getValue(labels[i])} className={s.line} style={{width: props.getPercent(k, total)+"%", background: props.colors[i]}}></div>);

    return (
        <div className={s.MetricChart}>
            {lines}
        </div>
    )
}

export default MetricChart;